import { call, put, takeLatest } from 'redux-saga/effects';

// constants for endpoints
import { ALERTS } from '../../../components/global/Server/endpoints';
import { HTTP_SUCCESS } from '../../constants/global';

// constants for actions
import {
  FETCH_ALERTS,
  FETCH_ALERT_SUMMARY,
  RESOLVE_ALERT,
  DELETE_ALL_ALERTS,
} from '../../constants/alerts';
import {
  clearStatus,
  requestStatus,
  showErrorMessage,
} from '../../actions/global';
import {
  fetchAlerts,
  fetchAlertSummary,
  storeAlerts,
  storeAlertSummary,
} from '../../actions/alerts';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/constants';
import { storeResponseMessage } from '../../actions/settings';
import AuthUtil from '../../AuthUtil';

function* fetchAlertsSaga(action) {
  yield call(clearStatus);
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ALERTS.FETCH_ALERTS, action.data)
    );
    const status = {
      status: response.status,
      statusText: response.statusText,
      success: response.status === HTTP_SUCCESS,
    };
    yield put(storeAlerts(response.data));

    yield put(requestStatus(status));
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
  }
}

// Counts only. Deliberately does NOT touch requestStatus: this runs on a
// timer and on every socket push, and hijacking the shared status slot
// would make unrelated screens flicker between loading and done.
function* fetchAlertSummarySaga(action) {
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ALERTS.FETCH_ALERT_SUMMARY, action.data)
    );
    yield put(storeAlertSummary(response.data));
  } catch (error) {
    // A failed count is not worth a toast — the badge simply holds its
    // last value until the next push or the five-minute tick.
  }
}

function* resolveAlertsSaga(action) {
  yield call(clearStatus);
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ALERTS.RESOLVE_ALERT, action.data)
    );
    if (response.data.success) {
      const status = {
        status: response.status,
        statusText: response.data.message,
        success: response.status === HTTP_SUCCESS,
      };
      yield put(storeResponseMessage(response.data.message));
      yield put(requestStatus(status));
    } else {
      const message = response.data.message || SERVER_FAILED_ERROR_MESSAGE;
      yield put(showErrorMessage(message));
    }
    yield put(fetchAlerts({ locationId: action.data.locationId }));
    yield put(fetchAlertSummary({ locationId: action.data.locationId }));
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
  }
}

function* deleteAllAlertsSaga(action) {
  yield call(clearStatus);
  try {
    const response = yield call(() =>
      AuthUtil.postRequest(ALERTS.DELETE_ALL_ALERTS, action.data)
    );
    if (response.data.success) {
      const status = {
        status: response.status,
        statusText: response.data.message,
        success: response.status === HTTP_SUCCESS,
      };
      yield put(storeResponseMessage(response.data.message));
      yield put(requestStatus(status));
    } else {
      const message = response.data.message || SERVER_FAILED_ERROR_MESSAGE;
      yield put(showErrorMessage(message));
    }
    yield put(fetchAlerts({ locationId: action.data.locationId }));
    yield put(fetchAlertSummary({ locationId: action.data.locationId }));
  } catch (error) {
    yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
  }
}

export default function* alertsSaga() {
  yield takeLatest(FETCH_ALERTS, fetchAlertsSaga);
  yield takeLatest(FETCH_ALERT_SUMMARY, fetchAlertSummarySaga);
  yield takeLatest(RESOLVE_ALERT, resolveAlertsSaga);
  yield takeLatest(DELETE_ALL_ALERTS, deleteAllAlertsSaga);
}
